import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorMessageModule } from '../../components/molecules/error-message/error-message.module';
import { SkeletonLoaderComponent } from '../../components/molecules/skeleton-loader/skeleton-loader.component';
import { SkeletonLoaderDirective } from './skeleton-loader.directive';

@NgModule({
  imports: [CommonModule, ErrorMessageModule],
  declarations: [SkeletonLoaderDirective, SkeletonLoaderComponent],
  exports: [SkeletonLoaderDirective]
})
export class SkeletonLoaderDirectiveModule {}
